import * as React from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export interface FormLabelProps extends React.ComponentPropsWithoutRef<typeof Label> {
  optional?: boolean;
}

const FormLabel = React.forwardRef<
  React.ElementRef<typeof Label>,
  FormLabelProps
>(({ className, children, optional, ...props }, ref) => (
  <Label ref={ref} className={cn('font-normal', className)} {...props}>
    {children}
    {optional && (
      <span className="text-xs font-normal text-muted-foreground ml-2">
        (optional)
      </span>
    )}
  </Label>
));
FormLabel.displayName = 'FormLabel';

export { FormLabel };
